<template>
  <div class="dashboard-container">
    <b-container fluid>
      <b-row>
        <b-col sm="12" md="2" lg="2">
          <NavBar
            @handleChange=handleChange
          />
        </b-col>
        <b-col sm="12" md="10" lg="10">
        <Dashboard v-if="tab_id == 1" :discord_id="discord_id"/>

        <Overview v-if="tab_id == 2" :discord_id="discord_id"/>
        </b-col>
      </b-row>
      

    </b-container>
  </div>
</template>

<script>
// import db from "../../database/index";
import NavBar from '@/components/NavBar'
import Dashboard from '@/components/JournalDashboard'
import Overview from '@/components/JournalOverview'

// import TradeTracking from '@/components/TradeTracking';

export default {
  name: "TradeJournal",
  metaInfo: {
    title: "Market Moves - Trade Journal",
    titleTemplate: "TradeJournal",
  },
  components: {
    // TradeTracking,
    NavBar,
    Overview,
    Dashboard

  },
  data() {
    return {
      id: this.$route.params.id,
      dataLoaded: false,
      discord_id: "",
      trades: [],
      tab_id: 1,
      fields: [
        {
          key: "date",
          // sortable: true,
        },
        {
          key: "details",
        },
        {
          key: "profit",
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    // Check is user is authorized to use dashboard
    // if (!this.$cookies.get("session_token")) this.$router.push({ path: "/" });

    this.discord_id = this.id;

  },
  methods: {
    handleChange(num){
      this.tab_id = num
    }
  },
};
</script>


<style scoped>
.trade-container {
  height: 240px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.search-container {
  height: 140px;
  width: 400px;
  background-color: #36393f;
  color: #f8f8f8;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 20px;
  box-shadow: 1px 1px 0px #282b2f, 2px 2px 0px #2f3033, 3px 3px 0px #282b2f,
    4px 4px 0px #2f3033, 5px 5px 0px #282b2f, 6px 6px 0px #2f3033;
}

.payment-header-wrapper {
  padding-top: 20px;
  font-weight: 800;
  font-size: 1.17em;
  text-transform: uppercase;
}

.cc-info-wrapper__1 {
  margin-top: 50px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__2 {
  margin-top: 25px;
  margin-bottom: 35px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.cc-info-wrapper__3 {
  margin-top: 20px;
  margin-bottom: 25px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 14px;
  text-align: justify;
}

.prevent-btn-container {
  display: flex;
  justify-content: space-evenly;
  margin-top: 12px;
}

.cc-info-text__1 {
  margin-top: 15px;
}

.cancel-sub button {
  background-color: #eb675e;
  border: #eb675e;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
  height: 28px;
}

.cancel-sub button:hover {
  background-color: #e98f88;
  border-color: #e98f88;
}

.cancel-sub button:active {
  position: relative;
  top: 1px;
}

.cancel-sub button:focus {
  outline: 0;
}

.cancel-confirmation {
  padding-top: 30px;
}

.cancel-confirmation-title {
  padding-left: 25px;
  padding-right: 25px;
  font-size: 1.17em;
  font-weight: 800;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 10px;
}

.cancel-confirmation-text {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 14px;
  text-align: justify;
}

.cancel-btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 15px;
}

.cancel-yes-btn {
  background: #eb675e;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-yes-btn:hover {
  background: #e98f88;
  border: #e98f88;
}

.cancel-no-btn {
  background: #7289da;
  width: 70px;
  height: 28px;
  border-radius: 12px;
  line-height: 28px;
  margin: 0 auto;
  font-size: 14px;
}

.cancel-no-btn:hover {
  background: #818fc0;
  border: #818fc0;
}

.resub button {
  background-color: #7289da;
  border: #7289da;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-size: 13px;
  padding: 6px 22px;
  text-decoration: none;
  width: 175px;
}

.resub button:hover {
  background-color: #818fc0;
}

.resub button:focus {
  outline: 0;
}

.splash {
  margin: 0 auto;
  padding-top: 76px;
}

.splash-content {
  width: 88px;
  height: 88px;
  margin: 0 auto;
  border: 3px solid #7289da;
  border: 3px solid transparent;
  border-top-color: #7289da;
  border-bottom-color: #7289da;
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>